import{b as o}from"../../tslib.es6-7789c282.js";import{makeVar as t}from"@apollo/client/cache";var i=t({unreadCount:0,notifications:[]}),n=function(t){i(o({},t))};export{n as setUserNotificationResult,i as userNotificationResult};
